import AuthenticationLayout from 'components/AuthLayout';
import { DefaultLoader, LoaderContainer } from 'components/Loader';
import MenteeFormEdit from 'components/UserForms/MenteeForm/MenteeFormEdit';
import {
  Errors,
  initialErrors,
  State,
} from 'components/UserForms/MenteeForm/types';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useSWR, { mutate } from 'swr';
import MenteeFormType from 'types/MenteeForm';
import privateAPI from 'utils/privateAxiosInstance';

const initialState: State = {
  jobSearch: null,
  careerPlan: null,
  studies: null,
  entrepreneurship: null,
  sharing: false,
  volunteerState: null,
  expertises: [],
  validatedDiploma: null,
  completedFormation: null,
  formationMatchingProject: null,
  intendedFormation: null,
  formationState: null,
  intendedDiploma: null,
  consideration: null,
  hobby: null,
  heardAboutMentorship: null,
  heardAboutMentorshipText: null,
  expectations: null,
  sharingPhone: null,
  sharingEmail: null,
};
const FillFormMentee: FC = () => {
  const [state, setState] = useState<State>(initialState);
  const [errors, setErrors] = useState<Errors>(initialErrors);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const { data: menteeForm, error } = useSWR<MenteeFormType>('/mentee-form/');
  useEffect(() => {
    if (menteeForm) {
      setState({
        jobSearch: menteeForm.jobSearch!,
        careerPlan: menteeForm.careerPlan!,
        studies: menteeForm.studies!,
        entrepreneurship: menteeForm.entrepreneurship!,
        sharing: menteeForm.sharing!,
        volunteerState: menteeForm.volunteerState!,
        expertises: menteeForm.expertiseFields!.map(
          (expertiseField) => expertiseField.expertise,
        ),
        validatedDiploma: menteeForm.validatedDiploma!,
        completedFormation: menteeForm.completedFormation!,
        formationMatchingProject: menteeForm.formationMatchingProject!,
        intendedFormation: menteeForm.intendedFormation!,
        formationState: menteeForm.formationState!,
        intendedDiploma: menteeForm.intendedDiploma!,
        consideration: menteeForm.consideration!,
        hobby: menteeForm.hobby!,
        heardAboutMentorship: menteeForm.heardAboutMentorship || null,
        heardAboutMentorshipText: menteeForm.heardAboutMentorshipText || null,
        expectations: menteeForm.expectations || null,
        sharingPhone: menteeForm.sharingPhone!,
        sharingEmail: menteeForm.sharingEmail!,
      });
    }
  }, [menteeForm]);

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    // checking number of priorities
    let priorities = 0;
    if (state.jobSearch === 'PRIORITY') {
      priorities += 1;
    }
    if (state.careerPlan === 'PRIORITY') {
      priorities += 1;
    }
    if (state.studies === 'PRIORITY') {
      priorities += 1;
    }
    if (state.entrepreneurship === 'PRIORITY') {
      priorities += 1;
    }
    if (priorities > 2) {
      window.scrollTo({ top: 0 });
      setLoading(false);
      return setErrors({
        ...initialErrors,
        priorityLevels: true,
      });
    }

    if (!(state.sharingEmail || state.sharingPhone)) {
      setLoading(false);
      return setErrors({
        ...initialErrors,
        permissions: true,
      });
    }

    privateAPI
      .post('/mentee-form/', state)
      .then((res) => {
        mutate('/mentee-form/');
        setLoading(false);
        window.scrollTo({ top: 0 });
        !res?.data?.invalid && navigate('/mentee/fill-profile');
      })
      .catch((err) => {
        setLoading(false);
        window.scrollTo({ top: 0 });
        if (err?.response?.status === 400) {
          return setErrors({
            ...initialErrors,
            badRequest: true,
          });
        }
        setErrors({
          ...initialErrors,
          general: true,
        });
      });
  };

  return menteeForm || error ? (
    <AuthenticationLayout
      title="Bénéficier du Mentorat avec l'Institut de l'Engagement (1/3)"
      backTo="/mentee/welcome"
      src_image="/logo_institut_mentorat.png"
    >
      <MenteeFormEdit
        title="Questionnaire de mentorat"
        subtitle={[
          'Grâce à vos réponses, nous identifierons le mentor avec lequel vous serez mis en relation.',
          'Ce mentor aura répondu à un questionnaire similaire, ce qui nous permettra de plus facilement identifier les binômes à constituer.',
          'IMPORTANT : les binômes seront formés selon la complémentarité de vos profils plutôt que sur la proximité géographique.',
        ]}
        marginTop="4.5rem"
        {...{ state, setState, handleSubmit, errors, setErrors, loading }}
        invalid={menteeForm?.invalid}
      />
    </AuthenticationLayout>
  ) : (
    <LoaderContainer height="calc(100vh - 3rem)">
      <DefaultLoader size={2} />
    </LoaderContainer>
  );
};

export default FillFormMentee;
